export default "__VITE_ASSET__Cy$M84SA__"